import PrivacyPolicyContainer from './PrivacyPolicyContainer';
export default PrivacyPolicyContainer;